import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import NavBar from '../Components/Main/NavBar';
import Footer from '../Components/Main/Footer';
import '../css/Main/Contact.css'

const Contact = () => {
  const API = process.env.REACT_APP_BACKEND_URL;
  const navigate=useNavigate();
  const [subject, setSubject] = useState('');
  const [name,setName]= useState('');
  const [email,setEmail]= useState('');
  const [phone,setPhone]= useState('');
  const [message,setMessage]= useState('');
  const [status,setStatus]=useState('');

  const location=useLocation();
  const [productName, setProductName] = useState();

  useEffect(() => {
    setProductName(location.state.product_name)
  },[location.state])

    const handleSubmit= async (e)=> {
      e.preventDefault();
      try {
        const response = await axios.post(`${API}/email`, {name, email, subject, phone, message});
        console.log(response.data);
        setStatus("Email elküldve!");
        navigate('/koszonjuk');
      } catch (error) {
        console.log(error);
        setStatus("Email küldése sikertelen!");
      }
    }
  return (
    <div>
        <NavBar/>
        <div  className='contact'>
        <form className='contact-form' onSubmit={handleSubmit}>
        <label htmlFor="">Teljes Név</label>
        <input type="text" placeholder='Teljes Név' value={name} onChange={(e) => setName(e.target.value)}/>
        <label htmlFor="">Email</label>
        <input type="text" placeholder='példa@gmail.com' value={email} onChange={(e) => setEmail(e.target.value)}/>
        <label htmlFor="">Tárgy</label>
        <input type="text" value={productName ? productName : subject} onChange={(e) => setSubject(e.target.value)} placeholder='Tárgy'/>
        <label htmlFor="">Telefonszám</label>
        <input type="text" placeholder='+36 ' value={phone} onChange={(e) => setPhone(e.target.value)}/>
        <label htmlFor="">Üzenet</label>
        <textarea className='ms' placeholder='üzenet'value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
        <button type='submit'>Küldés</button>
        <p>{status}</p>
        </form>
        </div>
        <Footer/>
    </div>
  )
}

export default Contact